<script lang="ts" setup>
import Star from '~/assets/icons/star.svg?component'

import Clutch from '~/assets/icons/cluth.svg?component'
import Goodfirms from '~/assets/icons/good-firm.svg?component'
</script>

<template>
  <div
    class="flex flex-col items-center justify-start px-4 py-0 xs:flex-row xs:justify-center xs:space-x-4 sm:px-6 sm:py-4 md:px-8 lg:justify-start lg:px-0"
  >
    <a href="https://clutch.co/profile/webamboos" target="_blank" rel="noreferrer noopener" aria-label="Clutch Reviews">
      <div class="flex items-center gap-x-1 xs:gap-x-2">
        <Clutch class="h-3 py-px sm:h-4" />
        <span class="text-sm font-bold text-main-700 sm:text-base">4.8</span>
        <Star v-for="i in 5" :key="i" class="w-3 sm:w-4" />
        <Paragraph size="small" class="hidden sm:block"> {{ $t('home.reviews.clutch') }} </Paragraph>
      </div>
    </a>

    <a href="https://clutch.co/profile/webamboos" target="_blank" rel="noreferrer noopener" aria-label="Clutch Reviews">
      <div class="flex items-center gap-x-1 xs:gap-x-2">
        <Goodfirms class="h-3 sm:h-4" />
        <span class="text-sm font-bold text-main-700 sm:text-base">5.0</span>
        <Star v-for="i in 5" :key="i" class="w-3 sm:w-4" />
        <Paragraph size="small" class="hidden sm:block"> {{ $t('home.reviews.goodfirms') }} </Paragraph>
      </div>
    </a>
  </div>
</template>
